import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { useValidationErrorHandle } from "sr/helpers/functions/validationErrorHandle";

type Props = {
  data: { special_instructions?: string };
  HandleDataProps: (payload: { special_instructions: string }) => void;
  externalErrorId?: string;
};

const RequirementSpecialInstructionsChange = forwardRef(({ data, HandleDataProps, externalErrorId }: Props, ref) => {
  const validationErrorHandle = useValidationErrorHandle();
  const [instructions, setInstructions] = useState("");

  useEffect(() => {
    setInstructions(data?.special_instructions || "");
  }, [data?.special_instructions]);

  useEffect(() => {
    HandleDataProps({ special_instructions: instructions });
  }, [instructions]);

  useImperativeHandle(ref, () => ({
    validateData: () => true, 
    submitForm: () => ({ special_instructions: instructions.trim() }),
  }));

  return (
    <div>
      <p className="pt-4 text-base">Special Instructions</p>
      <textarea
        className="w-full border rounded-lg p-2 mt-2"
        value={instructions}
        onChange={(e) => setInstructions(e.target.value)}
        placeholder="Enter any special instructions"
        rows={4}
      />
      {externalErrorId && (
        <p className="text-red-500 text-sm mt-1">{validationErrorHandle(externalErrorId)}</p>
      )}
    </div>
  );
});

export default RequirementSpecialInstructionsChange;
